import { TableHeader, TableRow, TableHead, cn } from 'twyne-new.ui';

import { useTableResizeContext } from '@Components/tableResize/context';
import { useColumnWidth } from '@Components/tableResize/hooks';

import ColumnResizer from './ColumnResizer';

export const Header = ({ columns, sticky, fixedFistColumnOnScroll = false, onResize }) => <>
  <TableHeader className='z-30 border-b twy-border-base' sticky={sticky}>
    <TableRow>
      {columns.map((column, index) => <>
        <HeaderItem
          key={index}
          column={column}
          index={index}
          fixedFistColumnOnScroll={fixedFistColumnOnScroll}
          onResize={onResize}
        />
      </>)}
    </TableRow>
  </TableHeader>
</>

const HeaderItem = ({ column, index, fixedFistColumnOnScroll, onResize }) => {
  const { activeResizeColumn, resizedColumns } = useTableResizeContext()
  const columnWidth = useColumnWidth({ columnIndex: index })
  const canBreakHeaderText = activeResizeColumn === index || resizedColumns.includes(index)

  return <HeaderItemResier
    column={column}
    index={index}
    fixedFistColumnOnScroll={fixedFistColumnOnScroll}
    columnWidth={columnWidth}
    canBreakHeaderText={canBreakHeaderText}
    style={columnWidth}
  >
    <ColumnResizer
      canResize={column.enableResize}
      isResizing={activeResizeColumn === index}
      onMouseDown={event => onResize({ columnIndex: index, event })}
    />
    {!column.text ? '' : typeof column.text === 'string' ? column.text : typeof column.text === 'function' ? column.text('', {}, index) : column.text}
  </HeaderItemResier>
}

const HeaderItemResier = ({ children, column, index, fixedFistColumnOnScroll, columnWidth, canBreakHeaderText }) => <>
  <TableHead
    className={cn(
      'relative group capitalize whitespace-nowrap cursor-pointer',
      canBreakHeaderText && 'whitespace-normal break-all',
      column.headerClassName,
      fixedFistColumnOnScroll && index === 0 && 'sticky top-0 left-0 z-30 twy-bg-base-accent',
    )}
    style={columnWidth}
  >
    {children}
  </TableHead>
</>
